import { cn } from "@/utils/cn"

export const baseStyles = cn(
  "inline-flex items-center justify-center font-medium",
  "rounded-md transition-colors",
  "focus:outline-none focus:ring-2 focus:ring-offset-2",
  "disabled:pointer-events-none disabled:opacity-50",
)

export const variantStyles = {
  primary: cn(
    "bg-primary-600 text-white",
    "hover:bg-primary-700",
    "focus:ring-primary-500",
  ),
  secondary: cn(
    "border border-gray-300 bg-white text-gray-700",
    "hover:bg-gray-50",
    "focus:ring-primary-500",
  ),
  ghost: cn("text-gray-700", "hover:bg-gray-100", "focus:ring-primary-500"),

  // TODO: this one needs work, it's nearly transparent
  danger: cn(
    "bg-error-600 text-white",
    "hover:bg-error-700",
    "focus:ring-error-500",
  ),
}

export const sizeStyles = {
  sm: "h-8 px-3 text-sm",
  md: "h-10 px-4 text-sm",
  lg: "h-12 px-6 text-base",
}
